import { Button } from 'blaze-ui/Button'
import { Icon } from 'blaze-ui/icons/Types'
import { Tooltip } from 'components/Tooltip/Tooltip'
import Styles from './EditCaptionModal.module.scss'

interface DisabledPickerTriggerProps {
  icon: Icon
  label: string
  tooltipLabel?: string
}

export const DisabledPickerTrigger = ({ icon, label, tooltipLabel }: DisabledPickerTriggerProps) => {
  const trigger = (
    <span className={Styles.disabledPickerTrigger}>
      <Button frontIcon={icon} variant="secondary" size="md" isDisabled aria-label={label}>
        {label}
      </Button>
    </span>
  )

  if (!tooltipLabel) return trigger

  return (
    <Tooltip label={tooltipLabel} placement="top">
      {trigger}
    </Tooltip>
  )
}
